import ProcessFollowup from '@/pages/Processes/ProcessFollowup.vue'
import FollowupDetails from '@/pages/Processes/FollowupDetails.vue'
import InitiateProcess from '@/pages/Processes/InitiateProcess.vue'

export default [
	
	{
		name: 'followup',
		path: '/processes/followup',
		component: ProcessFollowup,
		meta: {
			secure: true
		}
	},
	{
		name: 'followup-details',
		path: '/processes/followup-details/:processInstanceId',
		component: FollowupDetails,
		meta: {
			secure: true
		}
	},
	{
		name: 'initiate-process',
		path: '/processes/initiate-process/:workflowId',
		component: InitiateProcess,
		meta: {
			secure: true
		}
	},

]